import { Stack } from '@mui/material'
import { NavigationView } from '../../layout/NavigationView'
import { Typography } from '@eventr/common-storybook'
import { useRocketChatContext } from '../rocketChatProvider'

export const ChatNotificationsView = () => {
    const { chatView } = useRocketChatContext()

    return (
        <NavigationView
            navigationBarTitle={
                <Typography variant="mobileH3">
                    Notification Settings
                </Typography>
            }
            backButtonAction={() => {
                chatView.value = 'chatInfo'
            }}
            usePageTransition
        >
            <Stack>
                <div>Disable Notifications</div>
                <div>Disable Push Notifications</div>
            </Stack>
        </NavigationView>
    )
}
